import useMYOProviderDirectory from '@/hooks/provider/useMYOProviderDirectory';
import MYOProviderDirectoryCard from '@/modules/directory/cards/MYOProviderDirectoryCard';
import DirectoryPageTemplate from '@/modules/directory/DirectoryPageTemplate';
import { Text } from '@chakra-ui/react';
import { createFileRoute } from '@tanstack/react-router';

const ProviderDirectory = () => {
  const { isLoading, data, fetchNextPage, isFetchingNextPage, hasNextPage } = useMYOProviderDirectory();

  return (
    <DirectoryPageTemplate
      title="Available Providers"
      isLoading={isLoading}
      isFetchingNextPage={isFetchingNextPage}
      hasNextPage={hasNextPage}
      onViewMoreClick={fetchNextPage}
    >
      {data?.length === 0 && <Text variant={'urbanistSemiBoldSmallTitle'}>No Matching Providers at the moment.</Text>}
      {/* {data?.map((provider) => <EHRProviderDirectoryCard member={provider} key={provider?.id} />)} */}
      {data?.map((provider) => <MYOProviderDirectoryCard provider={provider} key={provider?._id} />)}
    </DirectoryPageTemplate>
  );
};

export const Route = createFileRoute('/_authenticated/_directory/_provider/directory/provider')({
  staticData: { title: 'Providers' },
  component: ProviderDirectory,
});
